"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useValidatedForm = exports.useCalculatedId = void 0;
var _react = require("react");
var _validators = require("../validators");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useValidatedForm = exports.useValidatedForm = function useValidatedForm() {
  var requiredRoot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var validations = (0, _react.useRef)({});
  var arrayValidations = (0, _react.useRef)({});
  var innerValidations = (0, _react.useRef)({});
  var dirtyRef = (0, _react.useRef)();
  var validate = (0, _react.useCallback)(function (validations) {
    var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var names = Object.keys(validations);
    var valid = names.length > 0 || !required;
    for (var _i = 0, _names = names; _i < _names.length; _i++) {
      var name = _names[_i];
      var ref = validations[name];
      if (!ref.valid) {
        ref.setBlur();
        valid = false;
      }
    }
    return valid;
  }, []);
  var isValid = (0, _react.useCallback)(function () {
    var validRoot = validate(validations.current, requiredRoot);
    var validArray = Object.values(arrayValidations.current).flatMap(function (el) {
      return el;
    }).map(function (el) {
      return validate(el);
    }).reduce(function (a, b) {
      return a && b;
    }, true);
    var validInner = Object.values(innerValidations.current).map(function (el) {
      return validate(el);
    }).reduce(function (a, b) {
      return a && b;
    }, true);
    return validRoot && validArray && validInner;
  }, [requiredRoot, validate]);
  var checkDirty = (0, _react.useCallback)(function (validations) {
    var names = Object.keys(validations);
    for (var _i2 = 0, _names2 = names; _i2 < _names2.length; _i2++) {
      var name = _names2[_i2];
      var ref = validations[name];
      if (ref.dirty) {
        return true;
      }
    }
    return false;
  }, []);
  var isDirty = (0, _react.useCallback)(function () {
    if (dirtyRef.current === undefined) {
      var dirtyRoot = checkDirty(validations.current);
      var dirtyArray = Object.values(arrayValidations.current).flatMap(function (el) {
        return el;
      }).map(function (el) {
        return checkDirty(el);
      }).reduce(function (a, b) {
        return a || b;
      }, false);
      var dirtyInner = Object.values(innerValidations.current).map(function (el) {
        return checkDirty(el);
      }).reduce(function (a, b) {
        return a || b;
      }, false);
      return dirtyRoot || dirtyArray || dirtyInner;
    }
    return dirtyRef.current;
  }, [dirtyRef, checkDirty]);
  var setPristine = (0, _react.useCallback)(function () {
    var dirty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    dirtyRef.current = dirty;
  }, []);
  var register = (0, _react.useCallback)(function (name, ref) {
    validations.current[name] = ref;
  }, []);
  var registerArray = (0, _react.useCallback)(function (property, index, name, ref) {
    if (!arrayValidations.current[property]) {
      arrayValidations.current[property] = [];
    }
    if (!arrayValidations.current[property][index]) {
      arrayValidations.current[property][index] = {};
    }
    var updated = arrayValidations.current[property][index];
    updated[name] = ref;
    arrayValidations.current[property][index] = updated;
  }, []);
  var registerInner = (0, _react.useCallback)(function (property, name, ref) {
    if (!innerValidations.current[property]) {
      innerValidations.current[property] = {};
    }
    var updated = innerValidations.current[property];
    updated[name] = ref;
    innerValidations.current[property] = updated;
  }, []);
  var clearArray = (0, _react.useCallback)(function () {
    arrayValidations.current = {};
  }, []);
  var clearInner = (0, _react.useCallback)(function () {
    innerValidations.current = {};
  }, []);
  var bindInputNode = (0, _react.useCallback)(function (el) {
    if (!el) return {};
    var base = {};
    for (var _i3 = 0, _Object$keys = Object.keys(el); _i3 < _Object$keys.length; _i3++) {
      var name = _Object$keys[_i3];
      var ref = el[name];
      base = Object.assign(Object.assign({}, base), _defineProperty({}, name, ref.value));
    }
    return base;
  }, []);
  var bindArray = (0, _react.useCallback)(function () {
    var _a;
    var base = {};
    for (var _i4 = 0, _Object$keys2 = Object.keys(arrayValidations.current); _i4 < _Object$keys2.length; _i4++) {
      var arrayName = _Object$keys2[_i4];
      var inputNodes = (_a = arrayValidations.current[arrayName]) !== null && _a !== void 0 ? _a : [];
      var array = inputNodes.filter(function (el) {
        return !!el;
      }).map(function (el) {
        return bindInputNode(el);
      });
      base = Object.assign(Object.assign({}, base), _defineProperty({}, arrayName, array));
    }
    return base;
  }, [bindInputNode]);
  var bindInner = (0, _react.useCallback)(function () {
    var base = {};
    for (var _i5 = 0, _Object$keys3 = Object.keys(innerValidations.current); _i5 < _Object$keys3.length; _i5++) {
      var name = _Object$keys3[_i5];
      var el = innerValidations.current[name];
      if (el) {
        base = Object.assign(Object.assign({}, base), _defineProperty({}, name, bindInputNode(el)));
      }
    }
    return base;
  }, [bindInputNode]);
  var bind = (0, _react.useCallback)(function () {
    var root = bindInputNode(validations.current);
    // proccessing array nodes
    var array = bindArray();
    // proccessing inner nodes
    var inner = bindInner();
    return Object.assign(Object.assign(Object.assign({}, root), array), inner);
  }, [bindInputNode, bindArray, bindInner]);
  return {
    isValid: isValid,
    isDirty: isDirty,
    register: register,
    bind: bind,
    registerArray: registerArray,
    registerInner: registerInner,
    clearArray: clearArray,
    clearInner: clearInner,
    setPristine: setPristine
  };
};
var calculateId = function calculateId(name, currentId) {
  if (currentId) {
    return;
  }
  return name.trim().toLowerCase().normalize('NFKD').replace(/(?:[\^`\xA8\xAF\xB4\xB7\xB8\u02B0-\u034E\u0350-\u0357\u035D-\u0362\u0374\u0375\u037A\u0384\u0385\u0483-\u0487\u0559\u0591-\u05A1\u05A3-\u05BD\u05BF\u05C1\u05C2\u05C4\u064B-\u0652\u0657\u0658\u06DF\u06E0\u06E5\u06E6\u06EA-\u06EC\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F5\u0818\u0819\u0898-\u089F\u08C9-\u08D2\u08E3-\u08FE\u093C\u094D\u0951-\u0954\u0971\u09BC\u09CD\u0A3C\u0A4D\u0ABC\u0ACD\u0AFD-\u0AFF\u0B3C\u0B4D\u0B55\u0BCD\u0C3C\u0C4D\u0CBC\u0CCD\u0D3B\u0D3C\u0D4D\u0DCA\u0E3A\u0E47-\u0E4C\u0E4E\u0EBA\u0EC8-\u0ECC\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F82-\u0F84\u0F86\u0F87\u0FC6\u1037\u1039\u103A\u1063\u1064\u1069-\u106D\u1087-\u108D\u108F\u109A\u109B\u135D-\u135F\u1714\u1715\u1734\u17C9-\u17D3\u17DD\u1939-\u193B\u1A60\u1A75-\u1A7C\u1A7F\u1AB0-\u1ABE\u1AC1-\u1ACB\u1B34\u1B44\u1B6B-\u1B73\u1BAA\u1BAB\u1BE6\u1BF2\u1BF3\u1C36\u1C37\u1C78-\u1C7D\u1CD0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1D2C-\u1D6A\u1DC4-\u1DCF\u1DF5-\u1DFF\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2CEF-\u2CF1\u2E2F\u302A-\u302F\u3099-\u309C\u30FC\uA66F\uA67C\uA67D\uA67F\uA69C\uA69D\uA6F0\uA6F1\uA700-\uA721\uA788-\uA78A\uA7F8\uA7F9\uA806\uA82C\uA8C4\uA8E0-\uA8F1\uA92B-\uA92E\uA953\uA9B3\uA9C0\uA9E5\uAA7B-\uAA7D\uAABF-\uAAC2\uAAF6\uAB5B-\uAB5F\uAB69-\uAB6B\uABEC\uABED\uFB1E\uFE20-\uFE2F\uFF3E\uFF40\uFF70\uFF9E\uFF9F\uFFE3]|\uD800\uDEE0|\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD22-\uDD27\uDD4E\uDD69-\uDD6D\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC46\uDC70\uDCB9\uDCBA\uDD33\uDD34\uDD73\uDDC0\uDDCA-\uDDCC\uDE35\uDE36\uDEE9\uDEEA\uDF3B\uDF3C\uDF4D\uDF66-\uDF6C\uDF70-\uDF74\uDFCE-\uDFD0\uDFD2\uDFD3\uDFE1\uDFE2]|\uD805[\uDC42\uDC46\uDCC2\uDCC3\uDDBF\uDDC0\uDE3F\uDEB6\uDEB7\uDF2B]|\uD806[\uDC39\uDC3A\uDD3D\uDD3E\uDD43\uDDE0\uDE34\uDE47\uDE99]|\uD807[\uDC3F\uDD42\uDD44\uDD45\uDD97\uDF41\uDF42\uDF5A]|\uD80D[\uDC47-\uDC55]|\uD818\uDD2F|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDD6B\uDD6C\uDF8F-\uDF9F\uDFF0\uDFF1]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uD838[\uDC30-\uDC6D\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDDEE\uDDEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD46\uDD48-\uDD4A])/g, '').replace(_validators.FIX_EXTERNAL_ID_REGEX, '_');
};
var useCalculatedId = exports.useCalculatedId = function useCalculatedId(id) {
  var _useState = (0, _react.useState)(id),
    _useState2 = _slicedToArray(_useState, 2),
    initialId = _useState2[0],
    setInitialId = _useState2[1];
  var validators = (0, _react.useMemo)(function () {
    return [new _validators.ExternalIdValidator()];
  }, []);
  var nameValidators = (0, _react.useMemo)(function () {
    return [new _validators.NoEmojiValidator()];
  }, []);
  var hasChangedName = (0, _react.useCallback)(function (name, value) {
    if (value === undefined || typeof value !== 'string') return;
    var calculatedId = calculateId(value, id);
    if (calculatedId !== undefined) {
      setInitialId(calculatedId);
    }
  }, [id]);
  return {
    initialId: initialId,
    hasChangedName: hasChangedName,
    validators: validators,
    nameValidators: nameValidators
  };
};